import React, { Component } from 'react';
import $ from 'jquery';
import 'is-in-viewport';
import './VideoPlayer.scss';
import playBtn from '../../../images/components/Video/playBtn.svg';
import replayBtn from '../../../images/components/Video/replayBtn.svg';
import { getFileName } from '../../../helpers/FileCaching';
import 'browsernizr/test/touchevents';
import Modernizr from 'browsernizr';
import { Offline, Online } from 'react-detect-offline';
import IsNotDomestic from 'helpers/IsNotDomestic';
import OfflineIcon from 'helpers/OfflineIcon';
import globalJSON from 'data/global.json';




class VideoPlayer extends Component {

	constructor(props) {
		super(props);

		if(props.videoImages){
			this.videoImages = props.videoImages;
		}else{
			this.videoImages = require.context('../../../images/components/Video', true, /.*\.(gif|png|jpe?g|svg)$/i);
		}
		

		this.state = {
			playing: false,
			muted: false,
			completed: false,
			inViewport: false,
			fullscreen: false,
			isMobile: false,
			hasStarted: false,
			isNotDomestic: false
		};

		this.videoWrapperRef = React.createRef();
		
		this.application = null;

		this.letTrackingVideos = {};

	}

	componentWillMount() {
		let self = this;
		self.setState({ isNotDomestic: IsNotDomestic.isNotDomesticUser });
		IsNotDomestic.checkDomesticUser(function() {
            self.setState({ isNotDomestic: IsNotDomestic.isNotDomesticUser });
		});
	}

	componentDidMount() {
		let self = this;
		
		this.$videoWrapper = $(this.videoWrapperRef.current);
		this.$video = this.$videoWrapper.find('#video');

		this.video = this.$video[0];
		this.videoContainer = this.$videoWrapper.find('#videoContainer')[0];
		this.videoSource = this.$videoWrapper.find('source')[0];
		this.videoControls = this.$videoWrapper.find('#video-controls')[0];
		this.videoCaption = this.$videoWrapper.find('#videoPlayer__caption')[0];
		this.videoEpisode = this.$videoWrapper.find('#videoPlayer__episode')[0];
		this.timeBar = this.$videoWrapper.find('#time-bar')[0];
		this.progressBar = this.$videoWrapper.find('#progress-bar')[0];
		this.playBtn = this.$videoWrapper.find('#videoPlayer__play-icon')[0];
		this.adContainer = this.$videoWrapper.find('#adContainer')[0];
		this.hideTimer = null;

		this.video.volume = 1;

		let mousedown = false;
		this.progressBar.addEventListener('click', this.timeScrub.bind(this));
		this.progressBar.addEventListener('mousedown', function(e) {
			mousedown = true;
			self.timeScrub(e);
		});
		document.addEventListener('mouseup', function(e) {
			if(mousedown) {
				mousedown = false;
				self.timeScrub(e);
			}
		});
		document.addEventListener('mousemove', function(e) {
			if(mousedown) {
				self.timeScrub(e);
			}
		});

		this.video.onloadedmetadata = this.setDuration.bind(this);
		this.video.ontimeupdate = this.setCurrentTime.bind(this);
		this.video.addEventListener('timeupdate', this.progressUpdate.bind(this));

		if(this.props.onComplete !== undefined){
			this.video.addEventListener('ended', this.props.onComplete);
		}

		document.onfullscreenchange = this.exitHandler.bind(this);

		this.videoControls.style.display = 'none';
		this.adContainer.style.display = 'none';

		$(window).on('scroll', function() {
			if(!self.$video.is(':in-viewport') && !self.video.paused) {
				self.video.pause();
			}
		});

		if(this.props.autoPlay === true){
			this.startVideo.bind(this)()
		}

	}

	playPauseToggle() {
		if(this.state.playing) {
			this.pause();
		} else {
			this.play();
		}
	}

	play() {
		this.video.play();
		this.setState({playing: true});
	}

	pause() {
		this.video.pause();
		this.setState({playing: false});
	}

	replay() {
		this.video.currentTime = 0;
		this.video.play();
		this.resetControls();
	}

	resetControls() {
		this.setState({completed: false});
		this.hidePlayBtn();
		this.videoControls.style.pointerEvents = 'all';
	}

	muteUnmuteToggle() {
		if(this.state.muted) {
			this.video.volume = 1;
			this.setState({muted: false});
		} else {
			this.video.volume = 0;
			this.setState({muted: true});
		}
	}

	fullscreenToggle() {
		if(!this.state.fullscreen && document.activeElement) {
			if (this.video.requestFullscreen) {
				this.video.requestFullscreen();
			} else if (this.video.mozRequestFullScreen) {
				this.video.mozRequestFullScreen();
			} else if (this.video.webkitRequestFullscreen) {
				this.video.webkitRequestFullscreen();
			} else if (this.video.msRequestFullscreen) {
				this.video.msRequestFullscreen();
			}else if(this.video.webkitSupportsFullscreen){
				this.video.webkitEnterFullscreen();
			}
		} else {
			if(document.fullscreen) {
				var cancelFullscreen = document.exitFullscreen ||
				document.msExitFullscreen ||
				document.webkitCancelFullScreen ||
				document.mozCancelFullScreen;
				if (cancelFullscreen) {
					try {
						cancelFullscreen.call(document);
					} catch(e) {
						console.log(e);
					}
				}
			}
		}

	}	

	exitHandler() {
		if(document.fullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement) {
			this.setState({fullscreen: true});	
		} else {
			this.setState({fullscreen: false});	
		}
	}

	setCurrentTime() {
		var ct = this.$videoWrapper.find('#ct')[0];
		ct.innerText = this.formatTime(this.video.currentTime);
	}

	setDuration() {
		var dr = this.$videoWrapper.find('#dr')[0];
		dr.innerText = this.formatTime(this.video.duration);
	}

	formatTime(duration) {
		var minutes = Math.floor(duration / 60);
		minutes = minutes < 10 ? `0${minutes}` : minutes; 
		var seconds = Math.round(duration % 60);
		seconds = seconds < 10 ? `0${seconds}` : seconds; 

		return `${minutes}:${seconds}`;
	}

	progressUpdate() {

		if(this.state.completed) {
			this.resetControls();
		}

		const percent = (this.video.currentTime / this.video.duration) * 100;
		this.timeBar.style.width = `${percent}%`;

		if(!this.video.paused) {
			this.setState({playing: true});
		} else {
			this.setState({playing: false});
		}

		if(Modernizr.touchevents) {
			this.setState({isMobile: Modernizr.touchevents});
			this.videoControls.style.display = 'none';
		}

		let trackingObject = {};
		if(!isNaN(percent)){
			trackingObject.progress = percent;
			trackingObject.src = this.videoSource.src;
			this.onVideoProgress(trackingObject);
		}

		if(this.video.duration > 0) {
			if(this.application === null) {
				this.videoCaption.style.opacity = 0;
				this.videoEpisode.style.opacity = 0;
			} else if(!this.application.adsActive_) {
				this.videoCaption.style.opacity = 0;
				this.videoEpisode.style.opacity = 0;
			}
		}

		if(this.video.currentTime === this.video.duration) {
			if(this.application === null) {
				this.setState({completed: true});
				this.showPlayBtn();
				this.videoControls.style.opacity = 0;
				this.videoControls.style.pointerEvents = 'none';
				this.setState({isMobile: false});
			} else if(!this.application.adsActive_) {
				this.setState({completed: true});
				this.showPlayBtn();
				this.videoControls.style.opacity = 0;
				this.videoControls.style.pointerEvents = 'none';
				this.setState({isMobile: false});
			}
		} 

	}

	timeScrub(e) {
		const progress = $(this.progressBar);
		const scrubTime = ((e.pageX - progress.offset().left) / progress.width()) * this.video.duration;
		this.video.currentTime = scrubTime;
	}

	showPlayBtn() {
		this.playBtn.style.display = 'block';
	}

	hidePlayBtn() {
        this.playBtn.style.display = 'none';
	}

	startVideo() {
		this.hidePlayBtn();

		if(window.Ads && !this.state.hasStarted && this.state.isNotDomestic) {
			this.application = new window.Application($, this.$videoWrapper);
			this.application.onClick_();
		}

		this.setState({hasStarted: true});

		if(typeof window.google === 'undefined' || !this.state.isNotDomestic) {
			this.play();
			this.adContainer.style.zIndex = -1;
			this.adContainer.style.display = 'none';
			this.videoControls.style.display = 'block';
		} else {
			this.adContainer.style.display = 'block';
			this.videoControls.style.display = 'block';
		}
	}

	showVideoControls() {
		if(typeof this.hideTimer !== 'undefined') {
			clearTimeout(this.hideTimer);
		}

		if(this.application === null) {
			this.videoControls.style.transition = 'opacity .4s ease-out';
			this.videoControls.style.opacity = 1;
			this.adContainer.style.zIndex = -1;
			this.adContainer.style.display = 'none';
		} else {
			if(this.application.adsActive_ !== null && !this.application.adsActive_ && !this.state.completed) {
				if(!this.state.completed) {
					this.videoControls.style.transition = 'opacity .4s ease-out';
					this.videoControls.style.opacity = 1;
				}
			}
		}
	}

	hideVideoControls() {
		var self = this;
		self.hideTimer = setTimeout(function() { 
			self.videoControls.style.opacity = 0;
		}, 1500);
	}
	

	checkVideoOffline() {
		if(!this.state.playing) {
			return (
				// Offline background image in base64 format
				<div className="videoPlayer__offline">
					<div className="videoPlayer__offline--text-container">
						<h2 className="videoPlayer__offline--title">{globalJSON['video']['offline']['title']}</h2>	
						<h3 className="videoPlayer__offline--subtitle">{globalJSON['video']['offline']['subtitle']}</h3>	
					</div>
					<div
						className="videoPlayer__offline--background"
						style={{backgroundImage: `url('${OfflineIcon}')`}}>
					</div>
				</div>
			)
		}	

		return null;
	}

	onVideoProgress(videoData) {
			
		let filename = videoData.src.replace(/^.*[\\\/]/, '');
		
		if(this.letTrackingVideos[filename] == undefined){
			this.letTrackingVideos[filename] = {
				progress:0,
				progress0Tracked:false,
				progress25Tracked:false,
				progress50Tracked:false,
				progress75Tracked:false,
				progress100Tracked:false,
			};
		}

		if(videoData.progress > this.letTrackingVideos[filename].progress){

			this.letTrackingVideos[filename].progress = parseInt(videoData.progress);

			if(this.letTrackingVideos[filename].progress >= 100){
				if(!this.letTrackingVideos[filename].progress100Tracked){
					this.trackVideoProgress(filename,100);
					this.letTrackingVideos[filename].progress100Tracked = true;
				}
			}else if(this.letTrackingVideos[filename].progress >= 75){
				if(!this.letTrackingVideos[filename].progress75Tracked){
					this.trackVideoProgress(filename,75);
					this.letTrackingVideos[filename].progress75Tracked = true;
				}
			}else if(this.letTrackingVideos[filename].progress >= 50){
				if(!this.letTrackingVideos[filename].progress50Tracked){
					this.trackVideoProgress(filename,50);
					this.letTrackingVideos[filename].progress50Tracked = true;
				}
			}else if(this.letTrackingVideos[filename].progress >= 25){
				if(!this.letTrackingVideos[filename].progress25Tracked){
					this.trackVideoProgress(filename,25);
					this.letTrackingVideos[filename].progress25Tracked = true;
				}
			}else if(this.letTrackingVideos[filename].progress >= 0){
				if(!this.letTrackingVideos[filename].progress0Tracked){
					this.trackVideoProgress(filename,0);
					this.letTrackingVideos[filename].progress0Tracked = true;
				}
			}

		}

	}

	trackVideoProgress(filename, progress){

		window.gtag('event', "video progress", {
			'event_category': globalJSON['tracking']['ga_category'],
			'event_label': filename + " play " + progress + "% progress",
			'value':10
		});

		
	}

	render() {
		const video = this.props.content.map((item, index) => {
			const Video_html =
				<div key={index} className={`videoPlayer ${this.props.stylesOverride}`} ref={this.videoWrapperRef}>
					<div id="videoContainer" className="videoPlayer__player-container videoPlayer__player-container--hidden">
						<video
							id="video" 
							width="100%" 
							height="100%"
							playsInline
							autobuffer="true"
							preload="none"
							controls={this.state.isMobile}
							poster={getFileName(this.videoImages, this.props.content[0].thumbnail.image[this.props.windowSize])}
							data-ad-tag={
								item['ad-preroll'] ? item['ad-preroll']['ad-tag'] : ''
							}
							data-ad-keywords={
								item['ad-preroll'] ? item['ad-preroll']['keywords'] : ''
							}
						>
							<source
								src={globalJSON['videoCdn'] + this.props.content[0].src[this.props.windowSize]}
								type="video/mp4" />
							Your browser does not support the video tag.
						</video>
                             
						<div className={`overlay_bottom`}></div>
						<div className="videoPlayer__caption_container">
							<div className="videoPlayer__episode" id="videoPlayer__episode">{ item.thumbnail.episode }</div>
							<div className="videoPlayer__caption" id="videoPlayer__caption">{ item.thumbnail.caption }</div>
						</div>
						<div className="video-controls" id="video-controls" onMouseEnter={this.showVideoControls.bind(this)} onMouseLeave={this.hideVideoControls.bind(this)}>
							<div className="gradient-layer"></div>
							<div className="progress-container">
								<div id="progress-bar" className="progress-bar">
									<div id="time-bar" className="time-bar"><span></span></div>
								</div>
							</div>
							<div className="video-controls-container">
								<div className="video-controls-container-child">
									<div className="left-container col-md-6">
										<button
											className={this.state.playing ? 'play-btn transparent-btn' : 'play-btn transparent-btn paused'}
											id="play-btn"
											onClick={this.playPauseToggle.bind(this)}>
											<i className="icon-pause"></i></button>
										<button
											className={this.state.muted ? 'volume-btn transparent-btn muted' : 'volume-btn transparent-btn unmuted'}
											onClick={this.muteUnmuteToggle.bind(this)}>
											<i className="icon-volume"></i></button>
									</div>
		
									<div className="right-container col-md-6">
										<div className="time">
											<p><span id="ct" className="ct">00:00</span> / <span id="dr" className="dr">00:00</span></p>
										</div>
										<button
											id="fullscreen-btn"
											className="fullscreen-btn transparent-btn"
											onClick={this.fullscreenToggle.bind(this)}>
											<i className="icon-resize-full-alt"></i></button>
									</div>
								</div>
							</div>
						</div>
						<div className="adContainer" id="adContainer"></div>
						<div className="videoPlayer__ad-text-container videoPlayer__ad-ui" id="videoPlayer__ad-text-container">
							<div className="videoPlayer__ad-message">Advertisement</div>
							<div className="videoPlayer__ad-countdown" id="videoPlayer__ad-countdown">&nbsp;&nbsp; seconds</div>
						</div>
						<div className="videoPlayer__ad-controls videoPlayer__ad-ui" id="videoPlayer__ad-controls">
							<button className="videoPlayer__ad-control-playtoggle" id="videoPlayer__ad-control-playtoggle"><i className="icon-pause"></i></button>
							<button className="videoPlayer__ad-control-soundtoggle" id="videoPlayer__ad-control-soundtoggle"><i className="icon-volume-off-1"></i></button>
						</div>
						<Online>
							{/* <div className="videoPlayer__play-icon--container"> */}
								{ !this.state.hasStarted || this.state.completed
									? (
										<div
											className="videoPlayer__play-icon"
											id="videoPlayer__play-icon"
											data-video-autoplay=""
											onClick={this.state.completed ? this.replay.bind(this): this.startVideo.bind(this)}
											style={this.state.completed ? {backgroundImage: 'url(' + replayBtn + ')'} : {backgroundImage: 'url(' + playBtn + ')'}}>
										</div>
									)
									: null
								}
							{/* </div> */}
						</Online>
						<Offline>
							{ this.checkVideoOffline() }
						</Offline>
					</div>
				</div>	
			
			return Video_html;
		});
	
		return <section>{video}</section>
	}
}

export default VideoPlayer;